export const getDashboardBanner = ({ organization }) =>
  organization?.configuration?.dashboardBanner || {};
